import './additional-products.scss';

import { Switch } from 'antd';
import { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Select } from '@/components/Shared/ui';
import { BankNames } from '@/constants';
import { GiftOutlined } from '@/media/antd-icons';
import { useAppSelector } from '@/store';

import { CreateTabContext } from '../../../ExistedOrder';
import { ADDITIONAL_PRODUCT_CODES } from '../../constants';
import type { CreateAutoCreditProps } from '../../types/form-types';
import type { TAddProducts } from '../../types/products';

interface IProps {
  products: TAddProducts[];
  periodOptions: Array<{
    value: string;
    label: string;
  }>;
  handleChangeProductInsurance: (data: {
    organizationId: string;
    addProductId: string;
  }) => void;
  handleAddProductsChange: (id: string) => void;
  handleChangeAddProductLoanPeriod: (data: {
    value: string;
    id: string;
  }) => void;
}

const AdditionalProducts: React.FC<IProps> = ({
  products,
  periodOptions,
  handleChangeProductInsurance,
  handleAddProductsChange,
  handleChangeAddProductLoanPeriod
}) => {
  const { addProductsInsurances } = useAppSelector((state) => state.dict);

  const { isFieldsFrozen } = useContext(CreateTabContext);
  const { control } = useFormContext<CreateAutoCreditProps>();

  return (
    <div className="additional-products">
      <div className="additional-products__title">Доп. продукты</div>

      <div className="additional-products__list">
        {products
          .filter((product) => !product.hidden && !product.hiddenByAutoType)
          .map((product, index) => {
            const insurancesPerProduct = addProductsInsurances
              ?.filter((item) => item.product.uuid === product.id)
              .map((item) => {
                return {
                  value: item.insurance.uuid,
                  label: item.insurance.name
                };
              });
            const giftProduct = product.price === 0;

            return (
              <Controller
                key={product.id}
                control={control}
                name={`additionalProducts.${index}`}
                render={() => (
                  <div
                    className="additional-products__list-item"
                    key={product.id}
                  >
                    <label className="additional-products__switch-checkbox">
                      <Switch
                        disabled={isFieldsFrozen}
                        checked={product.checked}
                        onChange={() => handleAddProductsChange(product.id)}
                      />
                      <div>
                        {product.label}

                        {product.price !== null && (
                          <div className="additional-products__price">
                            {giftProduct ? (
                              <>
                                <GiftOutlined /> В подарок
                              </>
                            ) : (
                              <>
                                Оплата:
                                <b>{product.price.toLocaleString('ru-RU')} ₸</b>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </label>

                    {product.code ===
                      ADDITIONAL_PRODUCT_CODES[BankNames.euBank].kasko && (
                      <div className="additional-products__period">
                        <Select
                          placeholder="Выберите период"
                          selectedValue={periodOptions.find(
                            (period) => period.value === product.loanPeriod
                          )}
                          onChange={(selectedValue) => {
                            handleChangeAddProductLoanPeriod({
                              value: selectedValue.value,
                              id: product.id
                            });
                          }}
                          options={periodOptions}
                          isFrozen={isFieldsFrozen}
                        />
                      </div>
                    )}

                    {insurancesPerProduct &&
                      insurancesPerProduct.length > 0 && (
                        <div className="additional-products__insurance">
                          <Select
                            placeholder="Выберите страхование"
                            selectedValue={insurancesPerProduct.find(
                              (period) => period.value === product.insuranceUuid
                            )}
                            onChange={(selectedValue) => {
                              handleChangeProductInsurance({
                                organizationId: selectedValue.value,
                                addProductId: product.id
                              });
                            }}
                            options={insurancesPerProduct}
                            isFrozen={isFieldsFrozen}
                          />

                          {/* TODO: Заменить проверку на код продукта, после выяснения срока действия Каско по Береке */}
                          {product.label === 'Каско по Береке' && (
                            <p className="additional-products__insurance-text">
                              12 месяцев
                            </p>
                          )}
                          {product.code ===
                            ADDITIONAL_PRODUCT_CODES[BankNames.bereke]
                              .insurance && (
                            <p className="additional-products__insurance-text">
                              На весь срок
                            </p>
                          )}
                        </div>
                      )}
                  </div>
                )}
              />
            );
          })}
      </div>
    </div>
  );
};

export default AdditionalProducts;
